import { authTokenStore } from "./authTokenStore";

export async function authenticatedFetch(
  input: RequestInfo,
  init: RequestInit = {},
): Promise<Response> {
  const token = authTokenStore.get();

  const requestHeaders =
    typeof Request !== "undefined" && input instanceof Request ? input.headers : undefined;

  const headers = new Headers(requestHeaders);

  new Headers(init.headers).forEach((value, key) => {
    headers.set(key, value);
  });

  const url = new URL(typeof input === "string" ? input : input.url, window.location.origin);

  const isInternalRequest = url.origin === window.location.origin;

  if (token && isInternalRequest && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, {
    ...init,
    headers,
  });
}

export async function fetchJson<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const response = await authenticatedFetch(input, init);

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
